import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import {ReactTyped} from 'react-typed';
import { motion } from 'framer-motion';
import Cube from '../components/Cube';
import Timeline from '../components/Timeline';
import TickerTape from '../components/TickerTape';
import { IconSwipeDown } from '@tabler/icons-react';


const AboutPage = () => {
    const data = useSelector((state) => state.data.data);
    const welcomeText = [
        `Hey, I am Arghya Mondal, a Fullstack Developer, based at Kolkata, West Bengal, India. I am an expert in MERN Stack, Django, and React Native. I have developed impactful solutions such as Morvox for empowering speech-disabled individuals.`
    ];

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    const linkVariants = {
        hidden: { opacity: 0, y: 50 },
        visible: (i) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: (i * 0.2)+12,
                duration: 1,
            }
        })
    };

    return (
        <div className='ml-auto mr-auto overflow-hidden max-w-5xl'>
            <div className="m-4 flex flex-col justify-center min-h-screen lg:min-h-96">
                <p className="font-bold sm:mt-28 mb-6">{`>./about.me`}</p>
                <div className="text-3xl sm:text-xl text-gray-300 max-w-3xl">
                    <ReactTyped
                        strings={welcomeText}
                        typeSpeed={40}
                        showCursor={true}
                    />
                </div>
                <div className="flex sm:justify-between mt-10">
                    {['linkedin', 'github', 'instagram', 'resume'].map((item, index) => (
                        <motion.div
                            key={item}
                            custom={index}
                            initial="hidden"
                            animate="visible"
                            variants={linkVariants}
                        >
                            <Link className="mr-8 sm:m-0 font-semibold" to={data.meta.social[item] || data.meta[item]}>
                                <span className='sm:hidden'>{`>. `}</span>
                                {item.charAt(0).toUpperCase() + item.slice(1)}
                            </Link>
                        </motion.div>
                    ))}
                </div>

                <motion.div
                    className='flex sm:flex-col mt-6 sm:mt-8'
                    initial={{ opacity: 0, x: -50 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 1, delay: 10 }}
                >
                    <Link target='_blank' to={data.meta.resume}><div className="btn sm:w-fit sm:mr-0 sm:mb-4 mr-4"><span>{`>.  `}</span>Download CV.</div></Link>
                    <Link to="/#contact"><div className="btn sm:w-fit alt-btn"><span>{`>.  `}</span>Contact Me.</div></Link>
                </motion.div>
            </div>

            <motion.div
                style={{flex: 0.6}} className="absolute swiper bottom-7 lg:hidden cursor-pointer"
                initial={{ opacity: 0, y: 50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 1, delay: 0.75 }}
            >
                <IconSwipeDown size={36} className='text-gray-600' stroke={1.5} />
            </motion.div>


            <div className="m-4 mt-20 sm:mt-40 flex md:flex-col lg:min-h-96">
                <div className="flex-1 flex justify-center items-center">
                    <Cube />
                </div>
                <div className="flex-1 flex flex-col justify-center items-end sm:items-start">
                    <p className="font-bold sm:mt-28 mb-6 text-right sm:text-left">{`>./my.music`}</p>

                    <motion.div className="text-3xl sm:text-xl text-right text-gray-300 sm:text-left max-w-3xl"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false }}
                        transition={{ duration: 0.5 }}
                        variants={{
                            hidden: { opacity: 0, x: 100 },
                            visible: { opacity: 1, x: 0 },
                        }}
                    >
                        Beyond coding, I am a Hindustani classical musician with 13+ years of experience. I am a singer, songwriter and a flutist and often perform solo flute recitals on local television.
                    </motion.div>
                    <motion.div
                        className='flex sm:flex-col mt-6 sm:mt-8'
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false }}
                        transition={{ duration: 0.5 }}
                        variants={{
                            hidden: { opacity: 0, x: 100 },
                            visible: { opacity: 1, x: 0 },
                        }}
                    >
                        <Link target='_blank' to={data.meta.social.music}><div className="btn alt-btn sm:w-fit sm:mr-0 sm:mb-4 mr-4"><span>{`>.  `}</span>Explore.</div></Link>
                    </motion.div>
                </div>
            </div>


            
            <Timeline />


            <TickerTape items={data.awards} />

            <div className="m-4 mt-20 min-h-screen sm:mt-40 flex md:flex-col lg:min-h-96">
                <div className="flex-1 flex flex-col items-center justify-center">

                    <motion.div className="text-3xl sm:text-xl text-center text-gray-300 max-w-3xl"
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false }}
                        transition={{ duration: 0.5 }}
                        variants={{
                            hidden: { opacity: 0, y: 100 },
                            visible: { opacity: 1, y: 0 },
                        }}
                    >
                        I belive in learning new things everyday. Thus I continuously upskill my self and build new and interesting projects. So, if you have an idea in mind fell free to let me know. We can turn it into reality together!
                    </motion.div>
                    <motion.div
                        className='flex sm:flex-col justify-center items-center mt-6 sm:mt-8'
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: false }}
                        transition={{ duration: 0.5 }}
                        variants={{
                            hidden: { opacity: 0, y: 100 },
                            visible: { opacity: 1, y: 0 },
                        }}
                    >
                        <Link to={`/#contact`}><div className="btn sm:w-fit sm:mr-0 sm:mb-4 mr-4"><span>{`>.  `}</span>Lets Connect.</div></Link>
                        <Link to={`/projects`}><div className="btn alt-btn sm:w-fit sm:mr-0 sm:mb-4 mr-4"><span>{`>.  `}</span>My Projects.</div></Link>
                    </motion.div>
                </div>
            </div>

        </div>
    );
}

export default AboutPage;
